import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import Link from '@material-ui/core/Link'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton'; 
import Alert from '@material-ui/lab/Alert';
import { AiOutlineArrowLeft } from 'react-icons/ai'
import dataProject from "../utils/projects-handler/dataProject";
import ListProject from '../components/ListProject';
import PortfolioFrame from '../components/PortfolioFrame';
import ButtonMore from '../components/ButtonMore';
import scrolls from "scrolls.js"
import { styleGoalGridContainer, styleSpan } from './styles'

const HeaderOfListProject = () => {
    return (
        <React.Fragment>
            <Grid item container justifyContent="center" xs={12}>
                <Typography variant="h4" align="center">Proyectos</Typography>
            </Grid>
            <Grid item container justifyContent="center">
                <Link component={RouterLink} to="/blog" color="inherit">
                    <IconButton 
                        className="icon-button" 
                        title="Blog" 
                        color="inherit"
                        style={{ 
                            background: "#d3d3d320",
                            fontSize: '14px'
                        }}
                        >
                        <AiOutlineArrowLeft />
                    </IconButton>
                    {' '}Ver blog
                </Link>
            </Grid>
        </React.Fragment>
    )
}


const ProjectsPage = ({ alert, setAlert }) => {
    const longDefault = 6
    const LONG_NAME = "longListProject"
    const SCROLL_Y = "projectsScrollY"
    const location = useLocation()
    const [long, setLong] = useState(longDefault)
    const [scrollY, setScrollY] = useState(0)

    function getScroll(){ return window.scrollY }

    useEffect(() => {
        const longLocalStorage = localStorage.getItem(LONG_NAME)

        if (longLocalStorage) {
            setLong(longLocalStorage)
            return
        }
    }, [])

    useEffect(() => {
        const scrollYLocalStorage = localStorage.getItem(SCROLL_Y);

        if (scrollYLocalStorage) {
            setScrollY(Number.parseInt(scrollYLocalStorage));
            return;
        }
    }, [])

    useEffect(()=>{
        if (!scrollY) {
            window.scroll(0,0)
            return
        }

        scrolls(scrollY)
        localStorage.removeItem(SCROLL_Y); 
    },[scrollY]);

    useEffect(() => {
        return ()=> {
            setAlert(false);
        }
    }, [])

    return(
        <PortfolioFrame>
            <Grid item container justifyContent="center" style={{color: "#fff", padding: "20px 0 20px 0"}}>
                <HeaderOfListProject />
                {
                    alert &&
                    <Alert 
                        onClose={()=> setAlert(false)} 
                        variant="outlined" 
                        style={{color: "white", margin: "20px 0 0 0"}} 
                        severity="info"
                    >
                        Selecciona un proyecto
                    </Alert>
                }
                <Grid item container justifyContent='center' xs={12} style={styleGoalGridContainer}>
                    <Grid 
                        item container 
                        direction='column' 
                        alignItems='center' 
                        xs={11} sm={10}
                    >
                        <Typography align='center' style={{fontSize: '18px'}}>
                            El objetivo de 
                                <span style={styleSpan}>
                                    {' '}Proyectos{' '}
                                </span> 
                            es tener mis principales proyectos en una sola página.
                        </Typography>
                    </Grid>
                </Grid>
                <ListProject data={dataProject} long={long} />
                <ButtonMore
                    longName={LONG_NAME}
                    longDefault={longDefault} 
                    long={long} 
                    setLong={setLong} 
                />
                <HeaderOfListProject />
            </Grid>
        </PortfolioFrame>
    );
}

export default React.memo(ProjectsPage);